import { ROLE } from 'helpers/constants';
import { useStore } from './store';

export const useIsRole = (roles = [], role) => {
  const { user } = useStore();
  return ROLE.isRole(role !== undefined ? role : user.role.code, roles);
};

export const useIsAdmin = role => useIsRole([ROLE.ADMIN], role);

export const useIsManager = role => useIsRole([ROLE.MANAGER], role);

export const useIsUser = role => useIsRole([ROLE.USER], role);
